import React from "react";
import PageDescription from "./PageDescription";

export default ({ image, title, description, colorSectionText }) => (
  <div className={{ color: colorSectionText }}>
    <div className="h-[100px] lg:h-[125px] xl:h-[158px] w-full mb-2 xl:mb-4">
      <img
        className="object-cover w-full h-full rounded-md"
        src={image}
        alt={title}
      />
    </div>
    <h4 className="mb-2 text-sm font-bold lg:text-base">{title}</h4>
    <PageDescription description={description} />
  </div>
);
